import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopoverOnInteraction } from '../../hooks/usePopoverOnInteraction';
import PopperPositionedPopover from '../../PopperPositionedPopover';
import DefaultPopoverContent from '../../_partials/DefaultPopoverContent';
/** Please note that this component is not DS-conforming */ const SimpleHoverPopperPopover = ({ children, popoverContent, positionFixed, eventsEnabled, referenceElement, hoverDelay, placement, secondaryPlacement, showArrow = true, className, arrowClassName, contentClassName, wrapperClassName, noPadding, isVisible: isVisibleProp = true, onVisible })=>{
    const isMobile = useContext(MobileContext);
    const { isVisible, onClick, onMouseEnter, onMouseLeave } = usePopoverOnInteraction({
        listenOnHover: !isMobile,
        hoverDelay,
        onVisible
    });
    const render = useCallback(({ effectivePlacement, effectiveSecondaryPlacement, contentStyle, arrowStyle, contentAttributes, arrowAttributes, rootRef, arrowRef, updatePositioning })=>{
        return /*#__PURE__*/ React.createElement(DefaultPopoverContent, {
            effectivePlacement: effectivePlacement,
            effectiveSecondaryPlacement: effectiveSecondaryPlacement,
            rootRef: rootRef,
            arrowRef: arrowRef,
            contentStyle: contentStyle,
            arrowStyle: arrowStyle,
            contentAttributes: contentAttributes,
            arrowAttributes: arrowAttributes,
            updatePositioning: updatePositioning,
            showArrow: showArrow,
            contentClassName: contentClassName,
            arrowClassName: arrowClassName,
            wrapperClassName: wrapperClassName,
            noPadding: noPadding,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, popoverContent);
    }, [
        arrowClassName,
        contentClassName,
        noPadding,
        onMouseEnter,
        onMouseLeave,
        popoverContent,
        showArrow,
        wrapperClassName
    ]);
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        usePortal: true,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        isVisible: isVisibleProp && isVisible,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        referenceElement: referenceElement,
        className: className,
        renderPopover: render,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave
    }, children);
};
SimpleHoverPopperPopover.displayName = 'SimpleHoverPopperPopover';
export default SimpleHoverPopperPopover;
